// frontend/src/components/DevLogin.tsx
// DEVELOPMENT ONLY - Remove before production deploy
// This component provides a quick bypass for authentication during local development

import React from 'react';
import { Box, Button, Typography, Paper, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { BugReport } from '@mui/icons-material';

export default function DevLogin() {
  const navigate = useNavigate();

  const handleDevLogin = () => {
    // Mock user data for development
    const mockUser = {
      id: 'dev-user-001',
      email: 'dev@local.test',
      name: 'Developer',
      role: 'admin',
      status: 'active',
      pages: ['dashboard', 'portfolio', 'people', 'location', 'map', 'methodology', 'monitor']
    };

    const mockToken = 'dev-token-' + Date.now();

    localStorage.setItem('token', mockToken);
    localStorage.setItem('user', JSON.stringify(mockUser));

    console.log('✅ Dev credentials injected!');
    console.log('User:', mockUser);

    // Navigate to location page
    navigate('/location');
  };

  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <Box 
      sx={{ 
        position: 'fixed', 
        bottom: 20, 
        right: 20, 
        zIndex: 9999 
      }}
    >
      <Paper 
        elevation={8} 
        sx={{ 
          p: 2, 
          bgcolor: '#1a1a1a', 
          color: 'white',
          border: '2px solid #ff9800',
          minWidth: 200
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <BugReport sx={{ color: '#ff9800' }} />
          <Typography variant="caption" sx={{ opacity: 0.9, fontWeight: 600 }}>
            Development Mode
          </Typography>
        </Box>
        
        <Chip 
          label="Local Only" 
          size="small" 
          sx={{ 
            mb: 1.5, 
            bgcolor: '#ff9800', 
            color: 'white',
            fontSize: '0.7rem',
            height: 20
          }} 
        />

        <Button
          variant="contained"
          color="warning"
          size="small"
          onClick={handleDevLogin}
          fullWidth
          sx={{ 
            fontWeight: 600,
            textTransform: 'none'
          }}
        >
          Skip Login (Dev)
        </Button>

        <Typography 
          variant="caption" 
          sx={{ 
            display: 'block', 
            mt: 1, 
            opacity: 0.6,
            fontSize: '0.65rem',
            textAlign: 'center'
          }}
        >
          Injects mock admin credentials
        </Typography>
      </Paper>
    </Box>
  );
}
